import {Command} from "../command";
import {CommandType} from "../commandType";
import * as $ from "jquery";
import {PopupType} from "../popups/popupType";
import {Application} from "../application";
import * as ko from "knockout";

export class OpenDefaultCompanyInfoPopupCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.OpenDefaultCompanyInfoPopup;
    canExecute = ko.computed(() => {
        return true;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show(PopupType.companyInfo, false, true);
    }

    name = "Edit Company Info";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/openDefaultCompanyInfoPopupCommand.ts